document.addEventListener("DOMContentLoaded", function () {
  initMenuHover();
  initCollapsibleTriggers();
  initSlideshowLinkHandler();
  setTimeout(initHorizontalScroll, 3000);
});

/**
 * Opens menu items on hover and closes them when the mouse leaves.
 */
function initMenuHover() {
  const menuItems = document.querySelectorAll(".header__inline-menu details");

  menuItems.forEach((item) => {
    item.addEventListener("mouseover", () => item.setAttribute("open", true));
    item.addEventListener("mouseleave", () => item.removeAttribute("open"));
  });
}

/**
 * Handles collapsible trigger clicks.
 */
function initCollapsibleTriggers() {
  document.querySelectorAll(".collapsible-trigger").forEach((trigger) => {
    trigger.addEventListener("click", function () {
      const content = this.nextElementSibling;
      const isExpanded = this.getAttribute("aria-expanded") === "true";

      this.setAttribute("aria-expanded", !isExpanded);
      content.classList.toggle("active");
    });
  });
}

/**
 * Redirects users when clicking on elements with the data-slideshowlink attribute.
 */
function initSlideshowLinkHandler() {
  document.addEventListener("click", function (event) {
    // Try to find either a slideshow__slide element or the slideshow container itself
    const slideElement = event.target.closest(".slideshow__slide");
    const slideshowElement = event.target.closest(".slideshow.banner");

    // If we found a slide element, use its link
    if (slideElement) {
      const linkUrl = slideElement.getAttribute("data-slideshowlink");

      if (linkUrl) {
        window.location.href = linkUrl;
        event.preventDefault(); // Prevent any default behavior
      }
    }
    // If no slide element but we found the slideshow, try to get the active slide
    else if (slideshowElement) {
      // Find the visible/active slide (the one without aria-hidden="true")
      const activeSlide = slideshowElement.querySelector(
        '.slideshow__slide:not([aria-hidden="true"])'
      );

      if (activeSlide) {
        const linkUrl = activeSlide.getAttribute("data-slideshowlink");

        if (linkUrl) {
          window.location.href = linkUrl;
          event.preventDefault();
        }
      }
    }
  });
}

function initHorizontalScroll() {
  const wrapper = document.querySelector(`.horizontal-scroll-wrapper`);
  if (!wrapper) return;

  const container = wrapper.querySelector(".horizontal-scroll-container");
  const leftButton = wrapper.querySelector(".scroll-button.scroll-left");
  const rightButton = wrapper.querySelector(".scroll-button.scroll-right");

  if (!container || !leftButton || !rightButton) return;

  // Variables for drag scrolling
  let isDown = false;
  let startX;
  let scrollLeft;

  // Calculate scroll amount (approx 75% of container width)
  const calculateScrollAmount = () => {
    return container.clientWidth * 0.75;
  };

  // Update button visibility
  const updateButtonVisibility = () => {
    // Hide left button if at start
    if (container.scrollLeft <= 10) {
      leftButton.classList.add("disabled");
    } else {
      leftButton.classList.remove("disabled");
    }

    // Hide right button if at end
    if (
      container.scrollLeft + container.clientWidth >=
      container.scrollWidth - 10
    ) {
      rightButton.classList.add("disabled");
    } else {
      rightButton.classList.remove("disabled");
    }
  };

  // Initial check
  updateButtonVisibility();

  // Button click handlers
  leftButton.addEventListener("click", function (e) {
    e.preventDefault();
    container.scrollBy({
      left: -calculateScrollAmount(),
      behavior: "smooth",
    });
  });

  rightButton.addEventListener("click", function (e) {
    e.preventDefault();
    container.scrollBy({
      left: calculateScrollAmount(),
      behavior: "smooth",
    });
  });

  // Mouse drag handlers
  container.addEventListener("mousedown", (e) => {
    isDown = true;
    container.classList.add("grabbing");
    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;

    // Prevent default text selection while dragging
    e.preventDefault();
  });

  container.addEventListener("mouseleave", () => {
    isDown = false;
    container.classList.remove("grabbing");
  });

  container.addEventListener("mouseup", () => {
    isDown = false;
    container.classList.remove("grabbing");
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - startX) * 1.5; // Scroll speed multiplier
    container.scrollLeft = scrollLeft - walk;
  });

  // Touch drag handlers for mobile
  container.addEventListener(
    "touchstart",
    (e) => {
      isDown = true;
      startX = e.touches[0].pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    },
    { passive: true }
  );

  container.addEventListener("touchend", () => {
    isDown = false;
  });

  container.addEventListener(
    "touchmove",
    (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - container.offsetLeft;
      const walk = (x - startX) * 1.5;
      container.scrollLeft = scrollLeft - walk;
    },
    { passive: true }
  );

  // Update button visibility on scroll
  container.addEventListener("scroll", updateButtonVisibility);

  // Update on resize
  window.addEventListener("resize", () => {
    updateButtonVisibility();
  });

  // Make sure the scroll container is visible
  container.style.display = "flex";
}
